angular
    .module('tradersyard')
    .run([
        'graph-api-client',
        'graph-conversation-factory',
        function ($api, $factory) {
            $api.factory.conversation = $factory;
        },
    ])
    .factory('graph-conversation-factory', [
        'graph-api-client',
        function (client) {
            return {};
        },
    ]);
